import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { apiService } from '../../../../../service/api.service';
import { ResponseCuentasModel, CuentasModel, ResponseCuentaJardinPeriodoModel, CuentaJardinPeriodoModel } from  '../../../../../model/Cuentas.model';

import { FormControl, FormGroup, Validators, ValidatorFn, FormGroupDirective, NgForm, FormBuilder, ValidationErrors } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { __assign } from 'tslib';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-modal-ficha-cuenta',
  templateUrl: './modal-ficha-cuenta.component.html',
  styleUrls: ['./modal-ficha-cuenta.component.css']
})
 
export class ModalFichaCuentaComponent implements OnInit {

  dataSelects = new CuentasModel();
  cuenta = new CuentaJardinPeriodoModel();
  idJardinPeriodo;
  arrayComunas = [];
  arrayModalidad = [];
  public formCuenta: FormGroup;
  stateRutValido = new StateRut(); 
  disabledCrear = true

  constructor(    
    public dialogRef: MatDialogRef<ModalFichaCuentaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: apiService,    
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
  
    
    this.formCuenta = this.formBuilder.group({
      idJardinPeriodo: new FormControl(),
      codigo: new FormControl( '',[Validators.required]),
      nombreJardin: new FormControl({ value: '', disabled: true }, [Validators.required]),
      programa: new FormControl({ value: '', disabled: true }, [Validators.required]),
      region: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.min(1)]),
      comuna: new FormControl({ value: -1, disabled: true }, [Validators.required, Validators.min(0)]),
      direccion: new FormControl({ value: '', disabled: true }, [Validators.required]),
      telefono: new FormControl({ value: '', disabled: true }, [Validators.required]),
      modalidad: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.min(1)]),

      rut: new FormControl({ value: '', disabled: true },[Validators.required, Validators.minLength(8), Validators.maxLength(10)]),
      nombreDirectora: new FormControl({ value: '', disabled: true }, [Validators.required]),
      correoInstitucional: new FormControl({ value: '', disabled: true }, [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      correoPersona: new FormControl({ value: '', disabled: true }, [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      telefonoDirectora: new FormControl({ value: '', disabled: true }, [Validators.required]),
      },{validator:[,this.validarRut]}
    );

    this.idJardinPeriodo = this.data.idJardinPeriodo;
    this.dataSelects = this.data.dataSelects;

    if(this.idJardinPeriodo != 0){
      this.formCuenta.controls['codigo'].disable();
      this.getCuenta();
    }   
  }

  crearCuenta(){

  }

  getCuenta(){
    this.api.API_POST_editarCuentaJardin(this.idJardinPeriodo).subscribe((response: ResponseCuentaJardinPeriodoModel) => {       
      this.cuenta = response.payload;
      this.llenarForm();
      this.enableForm(this.cuenta.idJardinPeriodo);
    },
    (err) => {
      console.log(err)
    })
  }

  buscar(){ 
    if(this.formCuenta.controls['codigo'].value != '' ){
      const codigo =this.formCuenta.controls['codigo'].value.replace('-','')
      this.api.API_POST_buscarCodigo(codigo).subscribe((response:ResponseCuentaJardinPeriodoModel) => {
        this.disabledCrear = false;
        if(response.payload.idJardinPeriodo != 0){
          Swal.fire({
            text: 'El código ingresado ya existe.',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        }else{
          this.enableForm(response.payload.idJardinPeriodo);
        }
      },
      (err) => {
        Swal.fire({
          text: 'El código ingresado ya existe.',
          icon: 'error',
          confirmButtonText: 'OK'
        })
        console.log(err)
      })
    }else{

    }
  }

  enableForm(id){
    const keys = Object.keys(this.formCuenta.controls);
    keys.forEach(key => {
      if(id != 0){
        if(key != 'codigo' && key != 'programa'){
          this.formCuenta.controls[key].enable();
        }
      }else{
        this.formCuenta.controls[key].enable();
      }
    });
  }
  
  llenarForm(){
    const keys = Object.keys(this.formCuenta.controls);
    keys.forEach(key => {
      this.formCuenta.controls[key].setValue(this.cuenta[key]);
    });

    this.seleccionarRegion();
    this.seleccionarModalidad(this.formCuenta.controls['programa'].value === 1 ? "Clásico" :  this.formCuenta.controls['programa'].value === 2 ? "Alternativo"  : "Clásico y Alternativo"   );
  }

  seleccionarRegion(){
    const indexRegion =this.dataSelects.regiones.map(element => element.idRegion).indexOf(this.formCuenta.controls['region'].value);
    this.arrayComunas = this.dataSelects.regiones[indexRegion].comunas;
  }

  validarRut(formulario:FormGroup){
    let rut = formulario.get('rut').value != null ? formulario.get('rut').value  : ''
    let cRut = rut.replace(/[\.-]/g, '');
    cRut = cRut.toUpperCase();
    var patt = /^\d{1,8}[0-9K]$/;
    var ok = patt.test(cRut);
    var cStr = cRut.slice(0, -1);
    var cDig = cRut.slice(-1);
    var nSum = 0;
    var nVal = 0;
    var cVal = "";

    if (ok) {
        for (let nMul = 2; cStr != ""; nMul = (nMul == 7) ? 2 : nMul + 1) {
            nSum += Number(cStr.slice(-1)) * nMul;
            cStr = cStr.slice(0, -1);
        }
        nVal = 11 - (nSum % 11);
        switch (nVal) {
            case 11:
                cVal = "0";
                break;
            case 10:
                cVal = "K";
                break;
            default:
                cVal = nVal.toString();
        }
        ok = cVal == cDig;
    }
    if(!ok && cRut.length >= 8 ){  
      return {rutValido:true};
    }else if(ok && (cRut.length >= 8 && cRut.length <=10)){ 
      return null;  
    } 
 
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.formCuenta.controls[controlName].hasError(errorName);  
  }

  guardar(){
   
    const keys = Object.keys(this.cuenta);
    keys.forEach(key => {
      this.cuenta[key] =this.formCuenta.controls[key].value;
    }); 

    this.formCuenta.controls.val

    if(this.formCuenta.valid){
      this.api.API_POST_guardarCuentaJardin(this.cuenta).subscribe((response) => {       
        this.dialogRef.close(this.cuenta);
      },
      (err) => {
        console.log(err)
      })
    }else{
      Object.keys(this.formCuenta.controls).forEach(field => {
        const control = this.formCuenta.get(field);
        control.markAsTouched({ onlySelf: true });
       });
    }

  }


  seleccionarModalidad(value){
    if(value === "Clásico"){
      this.arrayModalidad = this.dataSelects.modalidades.filter(element => element.descripcionCorta === "jardin_infantil");
    }else if (value ===  "Alternativo"){
      this.arrayModalidad = this.dataSelects.modalidades.filter(element => element.descripcionCorta != "jardin_infantil" && element.descripcionCorta != "familiar_y_laboral"  );
    }else{
      this.arrayModalidad = this.dataSelects.modalidades;
    }
  }
}



export class StateRut implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form:  FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

